import { SimpleDialogConfig, SimpleDialogData } from "./simple-dialog.model";
import { getBaseDialogData } from "../base-dialog/base-dialog.data";

export const getSimpleDialogData = (inputData: SimpleDialogData): SimpleDialogData => {
  const baseDialogData = getBaseDialogData(inputData?.title, inputData?.actions);

  const config: SimpleDialogConfig = { ...defaultConfig };

  if (inputData?.config) {
    const { width, closeOnNavigation, autoFocus } = inputData.config;

    if (width) {
      config.width = width;
    }
    if (typeof closeOnNavigation === 'boolean') {
      config.closeOnNavigation = closeOnNavigation;
    }
    if (typeof autoFocus === 'boolean') {
      config.autoFocus = autoFocus;
    }
  }

  return {
    ...baseDialogData,
    body: inputData?.body,
    config
  }
};

const defaultConfig: SimpleDialogConfig = {
  width: "500px",
  closeOnNavigation: true,
  autoFocus: false,
};
